<script>
  import {
    memberInfo,
    newOrderId,
    apiConfig,
    layoutOption,
    queryStr,
    appSetting,
    token,
  } from '../store/inapp-store';
  import {
    screenLight,
    closeWebview,
    openWebview,
    getAuthV,
    getAuthVAsync,
    getWalletStatus,
    getWalletStatusV3,
    onlinePayment,
    onlinePaymentOpw,
    onlinePaymentIcp,
    opOpenScanner,
    opOpenMemberGid,
    opQueryCameraStatus,
    opGetWebviewRange,
    opSetViewRang,
    setLocationPermission,
    getLocation,
    openByFeatureId
  } from '../store/openpoint';
  import { onMount } from 'svelte';

  $layoutOption.navTitle = 'OPAPP功能測試';
  $layoutOption.navBackUrl = `/home${$queryStr}`;
  $layoutOption.showCarousel = false;
  $layoutOption.showBanner = false;
  $layoutOption.showHome = false;
  $layoutOption.showCancel = false;
  $memberInfo.authV = '';



  function callGetAuthV() {
    authVAsyncResult = '';
    authVAsyncStatus = '等待中...';
    const input = document.getElementById('authV');
    if (input) input.value = '';
    try {
      getAuthV();
      let count = 0;
      const timer = setInterval(() => {
        const val = input?.value || '';
        if (val) {
          authVAsyncResult = val;
          authVAsyncStatus = '成功';
          $memberInfo.authV = val;
          clearInterval(timer);
        } else if (++count > 20) {
          authVAsyncStatus = '逾時';
          clearInterval(timer);
        }
      }, 500);
    } catch (e) {
      authVAsyncStatus = '失敗';
      authVAsyncResult = e.msg || String(e);
    }
  }

  let lightUp = false;
  let scannerType = 'Barcode';
  let regexContent = ['.*'];
  let showOpLogo = true;
  let title = '';
  let pageTypeSamples = [
    'point_home',
    'point_subpage',
    'point_search',
    'favorite',
    'reward',
    'presale',
    'brand',
    'reward_subpage',
    'member_badge',
    'presale_salebarcode',
    'point_olpaypage',
    'presale_subpage',
    'public_page_type1',
    'public_page_type2',
    'presale_page_type1',
  ];
  let pageType = 'point_search';
  let openUrl = 'https://emap.pcsc.com.tw'
  let openMode = 'ON'
  let featureId = 'IDP01B01P2S1'
  let source = 'CBW'
  let data = ''
  let icpBridgeUrl = $appSetting.icpBridgeUrl || ''
  let icpTradeToken = $token || ''
  let icpOpenMode = 'IN'
  $: icpo002Url = icpBridgeUrl
    ? `${icpBridgeUrl}?Actions=Mainaction&Event=ICPO002&Value=${encodeURIComponent(icpTradeToken)}&Valuetype=1`
    : ''

  function openIcpBridgeUrl() {
    if (!icpo002Url) { alert('請填入 icpBridgeUrl'); return }
    try {
      openWebview(icpOpenMode === 'IN', icpo002Url)
    } catch(e) {
      alert(e.msg)
    }
  }

  function toggleScreenLight() {
    lightUp = !lightUp;
    try {
      screenLight(lightUp);
    } catch (e) {
      alert(e.msg);
    }
  }

  function toggleopQueryCameraStatus() {
    try {
      opQueryCameraStatus();
    } catch (e) {
      alert(e.msg);
    }
  }

  function toggleopOpenScanner() {
    try {
      opOpenScanner(scannerType, regexContent);
    } catch (e) {
      alert(e.msg);
    }
  }

  function toggleopOpenMemberGid() {
    try {
      opOpenMemberGid();
    } catch (e) {
      alert(e.msg);
    }
  }

  function toggleopOPGetWebviewRange() {
    showOpLogo = !showOpLogo;
    try {
      opGetWebviewRange(showOpLogo);
    } catch (e) {
      alert(e.msg);
    }
  }

  function toggleopReload() {
    location.reload();
  }

  function toggleopOpSetViewRang() {
    try {
      opSetViewRang(pageType, title);
    } catch (e) {
      alert(e.msg);
    }
  }

  function toggleOpenWebview() {
    if(openUrl === '') { return false }
    try {
      var is_inapp = openMode === 'ON'
      openWebview(is_inapp, openUrl);
    } catch (e) {
      alert(e.msg);
    }
  }

  function toggleOpenFeature() {
    try {
      openByFeatureId(featureId, '');
    } catch (e) {
      alert(e.msg);
    }
  }

  function toggleGetWalletStatus() {
    try {
      getWalletStatus();
    } catch (e) {
      alert(e.msg);
    }
  }

  function toggleGetWalletStatusV3() {
    try {
      getWalletStatusV3();
    } catch (e) {
      alert(e.msg);
    }
  }

  function toggleOnlinePayment() {
    try {
      onlinePayment(source, data);
    } catch (e) {
      alert(e.msg);
    }
  }

  function toggleOnlinePaymentOpw() {
    try {
      onlinePaymentOpw(source, data);
    } catch (e) {
      alert(e.msg);
    }
  }

  function toggleOnlinePaymentIcp() {
    try {
      onlinePaymentIcp(source, data);
    } catch (e) {
      alert(e.msg);
    }
  }

  let authVAsyncResult = '';
  let authVAsyncStatus = '';

  async function callGetAuthVAsync() {
    authVAsyncResult = '';
    authVAsyncStatus = '等待中...';
    try {
      const authV = await getAuthVAsync();
      authVAsyncResult = authV || '(空字串)';
      authVAsyncStatus = '成功';
    } catch (e) {
      authVAsyncResult = e?.message || String(e);
      authVAsyncStatus = '失敗';
    }
  }

  $:console.log('scannerType=', scannerType)

</script>

<div>
  <div class="hb-sm-w-ms">
    <div class="hb-sm-w-ma">
      <div class="hb-sm-w">
        <span class="hb-sm-w-nm">1</span>
      </div>
      <span class="hb-w-mt-t" on:click={closeWebview}>關閉Webview</span>
    </div>

    <hr />

    <div class="hb-sm-w-ma">
      <div class="hb-sm-w">
        <span class="hb-sm-w-nm">2</span>
      </div>
      <span class="hb-w-mt-t" on:click={toggleScreenLight}>螢幕亮度調整</span>
    </div>

    <hr />

    <div class="hb-sm-w-ma">
      <div class="hb-sm-w">
        <span class="hb-sm-w-nm">3</span>
      </div>
      <span class="hb-w-mt-t">OP APP入口參數</span>
    </div>
    <div class="hb-w-mtts">
      <textarea class="hb-w-mtts-btn">{$queryStr}</textarea>
    </div>

    <hr />

    <div class="hb-sm-w-ma">
      <div class="hb-sm-w">
        <span class="hb-sm-w-nm">4</span>
      </div>
      <span class="hb-w-mt-t" on:click={() => (location.href = '/store-emap')}
        >7-11 電子地圖</span
      >
    </div>

    <hr />

    <div class="hb-sm-w-ma">
      <div class="hb-sm-w">
        <span class="hb-sm-w-nm">5</span>
      </div>
      <span class="hb-w-mt-t" on:click={toggleopQueryCameraStatus}
        >取得相機權限</span
      >
    </div>
    <div class="hb-w-mtts">
      <textarea id="isCamera" class="hb-w-mtts-btn" />
    </div>

    <hr />

    <div class="hb-sm-w-ma">
      <div class="hb-sm-w">
        <span class="hb-sm-w-nm">6</span>
      </div>
      <span class="hb-w-mt-t" on:click={toggleopOpenScanner}>開啟掃描器</span>
    </div>

    <div class="payment">
      <div class="pay-wrap" on:click={()=> scannerType = 'Barcode'}>
          <label for="a" class="pay-label">
              <input name="refundType" type="radio" id="a" class="a-in" bind:group={scannerType} value="Barcode">
              <span class="a-sn"><img src="img/atom-button-control-radio-button-btn-radio-t.svg" alt=""></span>
          </label>
          <p>&nbsp;一維條碼</p>
      </div>
      <div class="pay-wrap pt-2" on:click={()=> scannerType = 'QRCode'}>
          <label for="b" class="pay-label">
              <input name="refundType" type="radio" id="b" class="a-in" bind:group={scannerType}  value="QRCode">
              <span class="a-sn"><img src="img/atom-button-control-radio-button-btn-radio-t.svg" alt=""></span>
          </label>
          <p>&nbsp;二維碼</p>
      </div>
    </div>

    <div class="hb-sm-w-ma">
      <!-- <input
        id="scannerType"
        placeholder="ex:QRCode,Barcode"
        class="hb-w-mtts"
        on:change={(e) => {
          scannerType = e.target.value;
        }}
      /> -->
      <input
        id="regexContent"
        placeholder="正則逗點區分,ex:AAA,BBB"
        class="hb-w-mtts"
        on:change={(e) => {
          regexContent = e.target.value.split(',');
        }}
      />
    </div>
    <div class="hb-w-mtts">
      <textarea id="statusCode" class="hb-w-mtts-btn" />
    </div>
    <div class="hb-w-mtts">
      <textarea id="scanContentList" class="hb-w-mtts-btn" />
    </div>
    <hr />

    <div class="hb-sm-w-ma">
      <div class="hb-sm-w">
        <span class="hb-sm-w-nm">7</span>
      </div>
      <span class="hb-w-mt-t" on:click={toggleopOpenMemberGid}>開啟GID頁面</span
      >
    </div>

    <hr />

    <div class="hb-sm-w-ma">
      <div class="hb-sm-w">
        <span class="hb-sm-w-nm">8</span>
      </div>
      <span class="hb-w-mt-t" on:click={toggleopOPGetWebviewRange}
        >開關天區</span
      >
    </div>

    <hr />

    <div class="hb-sm-w-ma">
      <div class="hb-sm-w">
        <span class="hb-sm-w-nm">9</span>
      </div>
      <span class="hb-w-mt-t" on:click={toggleopReload}>Location.reload</span>
    </div>

    <hr />

    <div class="hb-sm-w-ma">
      <div class="hb-sm-w">
        <span class="hb-sm-w-nm">10</span>
      </div>
      <span class="hb-w-mt-t" on:click={toggleopOpSetViewRang}
        >設定webview顯示的範圍與</span
      >
    </div>
    <div class="hb-sm-w-ma">
      <select id="pageType" bind:value={pageType}>
        {#each pageTypeSamples as pageTypeSample}
          <option value={pageTypeSample}>
            {pageTypeSample}
          </option>
        {/each}
      </select>
      <input
        id="title"
        placeholder="沒Title則填空"
        class="hb-w-mtts"
        on:change={(e) => {
          title = e.target.value;
        }}
      />
    </div>

    <hr />

    <div class="hb-sm-w-ma">
      <div class="hb-sm-w">
        <span class="hb-sm-w-nm">11</span>
      </div>
      <span class="hb-w-mt-t" on:click={toggleOpenWebview}>另開Webview</span>
      <div class="hb-sm-w">
        <span class="hb-sm-w-nm" on:click={()=> openMode = openMode === 'ON'? 'OFF' : 'ON'}>{openMode}</span>
      </div>
    </div>
    <div class="hb-w-mtts">
      <textarea class="hb-w-mtts-btn">{openUrl}</textarea>
    </div>

    <hr />

    <div class="hb-sm-w-ma">
      <div class="hb-sm-w">
        <span class="hb-sm-w-nm">12</span>
      </div>
      <span class="hb-w-mt-t" on:click={setLocationPermission}>設定定位權限</span>
    </div>
   
    <hr />

    <div class="hb-sm-w-ma">
      <div class="hb-sm-w">
        <span class="hb-sm-w-nm">13</span>
      </div>
      <span class="hb-w-mt-t" on:click={getLocation}>取得經緯度座標</span>
    </div>
    <div class="hb-sm-w-ma">
      <div class="hb-w-mtts">
        <textarea id="permission" class="hb-w-mtts-btn" placeholder="定位權限狀態"/>
      </div>
      <div class="hb-w-mtts">
        <textarea id="latitude" class="hb-w-mtts-btn" placeholder="latitude緯度"/>
      </div>
      <div class="hb-w-mtts">
        <textarea id="longitude" class="hb-w-mtts-btn" placeholder="longitude經度"/>
      </div>
    </div>

    <hr />

    <div class="hb-sm-w-ma">
      <div class="hb-sm-w">
        <span class="hb-sm-w-nm">14</span>
      </div>
      <span class="hb-w-mt-t" on:click={toggleOpenFeature}>另開功能</span>
    </div>
    <div class="hb-w-mtts">
      <textarea class="hb-w-mtts-btn">{featureId}</textarea>
    </div>

    <hr />
    
    <div class="hb-sm-w-ma">
      <div class="hb-sm-w">
        <span class="hb-sm-w-nm">15</span>
      </div>
      <span class="hb-w-mt-t">
        <span on:click={toggleGetWalletStatus}>取得錢包狀態(舊)｜</span>
        <span on:click={toggleGetWalletStatusV3}>取得錢包狀態(新)</span>
      </span>
    </div>
    <div class="hb-w-mtts">
      <textarea id="walletStatus" class="hb-w-mtts-btn" placeholder="錢包狀態"/>
    </div>
    <div class="hb-w-mtts">
      <textarea id="isOpw" class="hb-w-mtts-btn" placeholder="是否有OPEN錢包信用卡交易工具"/>
    </div>
    <div class="hb-w-mtts">
      <textarea id="isIcashpay" class="hb-w-mtts-btn" placeholder="是否有登入icash Pay帳號"/>
    </div>
    <div class="hb-w-mtts">
      <textarea id="opwcardIssuerList" class="hb-w-mtts-btn" placeholder="OPEN錢包信用卡發卡行列表"/>
    </div>


    <hr />

    <div class="hb-sm-w-ma">
      <div class="hb-sm-w">
        <span class="hb-sm-w-nm">16</span>
      </div>
      <span class="hb-w-mt-t">
        <span on:click={toggleOnlinePayment}>線上支付 (舊)｜</span>
        <span on:click={toggleOnlinePaymentIcp}>(ICPO)｜</span>
        <span on:click={toggleOnlinePaymentOpw}>(NEWOPW)</span>
        <div class="hb-sm-w-ma">
          <div class="hb-w-mtts">
            <textarea class="hb-w-mtts-btn" placeholder="要進行線上支付的平台代號">{source}</textarea>
          </div>
          <div class="hb-w-mtts">
            <textarea class="hb-w-mtts-btn" placeholder="加密電文">{data}</textarea>
          </div>
        </div>
      </span>
    </div>
    <div class="hb-w-mtts">
      <textarea id="payStatus" class="hb-w-mtts-btn" placeholder="線上支付結果"/>
    </div>
    <div class="hb-w-mtts">
      <textarea id="payResultMsg" class="hb-w-mtts-btn" placeholder="線上支付結果訊息"/>
    </div>
    <div class="hb-w-mtts">
      <textarea id="merchantTradeNo" class="hb-w-mtts-btn" placeholder="商家端訂單編號"/>
    </div>
    <div class="hb-w-mtts">
      <textarea id="terminalId" class="hb-w-mtts-btn" placeholder="商家的公司統編"/>
    </div>
    <div class="hb-w-mtts">
      <textarea id="payErrorCode" class="hb-w-mtts-btn" placeholder="線上支付錯誤代碼"/>
    </div>

    <hr />

    <div class="hb-sm-w-ma">
      <div class="hb-sm-w">
        <span class="hb-sm-w-nm">17</span>
      </div>
      <span class="hb-w-mt-t" on:click={openIcpBridgeUrl}>開啟 ICP 橋接 URL</span>
      <div class="hb-sm-w">
        <span class="hb-sm-w-nm" on:click={() => icpOpenMode = icpOpenMode === 'IN' ? 'OUT' : 'IN'}>{icpOpenMode}</span>
      </div>
    </div>
    <div class="hb-sm-w-ma">
      <div class="hb-w-mtts">
        <textarea class="hb-w-mtts-btn" placeholder="icpBridgeUrl" bind:value={icpBridgeUrl}></textarea>
      </div>
      <div class="hb-w-mtts">
        <textarea class="hb-w-mtts-btn" placeholder="TradeToken" bind:value={icpTradeToken}></textarea>
      </div>
    </div>
    <div class="hb-w-mtts">
      <textarea class="hb-w-mtts-btn" placeholder="組合後的 URL（唯讀）" readonly>{icpo002Url}</textarea>
    </div>

    <hr />

    <div class="hb-sm-w-ma">
      <div class="hb-sm-w">
        <span class="hb-sm-w-nm">18-19</span>
      </div>
      <span class="hb-w-mt-t" on:click={callGetAuthV}>取得 AuthV</span>
      <span style="margin: 0 0.5rem;">|</span>
      <span class="hb-w-mt-t" on:click={callGetAuthVAsync}>AuthV（Promise）</span>
    </div>
    <input type="hidden" id="authV" />
    <div class="hb-w-mtts">
      <textarea class="hb-w-mtts-btn" placeholder="狀態" readonly>{authVAsyncStatus}</textarea>
    </div>
    <div class="hb-w-mtts">
      <textarea class="hb-w-mtts-btn" placeholder="authV 回傳值" readonly>{authVAsyncResult}</textarea>
    </div>
  </div>

</div>